import { render } from "./WorkspaceCreateNew.vue?vue&type=template&id=4219e03a&scoped=true&bindings={\"newWorkspaceName\":\"data\",\"activeWorkspaceId\":\"options\",\"cancel\":\"options\",\"submit\":\"options\",\"postWorkspace\":\"options\"}"
import script from "./WorkspaceCreateNew.vue?vue&type=script&lang=js"
export * from "./WorkspaceCreateNew.vue?vue&type=script&lang=js"

import "./WorkspaceCreateNew.vue?vue&type=style&index=0&id=4219e03a&scoped=true&lang=css"
script.render = render
script.__scopeId = "data-v-4219e03a"

export default script